import type { IconButtonType, IconButtonVariant } from '@latitude/icon-button';
import type { StepperVariant } from 'types';

/**
 * Determines the button variant based on the stepper variant.
 *
 * @param variant - The stepper variant.
 * @returns The button variant.
 */
export const getButtonVariant = (
  variant: StepperVariant,
): IconButtonVariant => {
  return variant === 'neutral' ? 'strong' : variant;
};

/**
 * Determines the button type based on the stepper variant.
 *
 * @param variant - The stepper variant.
 * @returns The button type.
 */
export const getButtonType = (variant: StepperVariant): IconButtonType => {
  return variant === 'neutral' ? 'ghost' : 'outline';
};
